// Tiny DOM helper. Text always goes through textContent, never innerHTML, because titles
// and names come from an external source.

type Child = Node | string | number | null | undefined | false;
type Attrs = Record<string, string | number | boolean | null | undefined | EventListener>;

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs | null = null,
  ...children: (Child | Child[])[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs ?? {})) {
    if (value === null || value === undefined || value === false) continue;
    if (key.startsWith("on") && typeof value === "function") {
      el.addEventListener(key.slice(2).toLowerCase(), value);
    } else if (key === "class") {
      el.className = String(value);
    } else {
      el.setAttribute(key, value === true ? "" : String(value));
    }
  }
  append(el, children);
  return el;
}

export function append(el: Element, children: (Child | Child[])[]): void {
  for (const child of children.flat()) {
    if (child === null || child === undefined || child === false) continue;
    el.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }
}

export function svg(markup: string): Element {
  // Only used for static, trusted markup written in this code base.
  const template = document.createElement("template");
  template.innerHTML = markup.trim();
  return template.content.firstElementChild as Element;
}

export function formatNumber(n: number, lang: string): string {
  return new Intl.NumberFormat(lang === "de" ? "de-DE" : "en-GB").format(n);
}
